import React, { useEffect, useState, useRef } from 'react'
import './ServerLogs.css'
import '../../Page.css';
import topApiIcon from '../../../Assets/Images/top-api.png';
import distributionsIcon from '../../../Assets/Images/distributions.png';
import methodsIcon from '../../../Assets/Images/methods.png'
import AnalyticCard from '../../../Components/DatabaseInsightComponents/AnalyticCard/AnalyticCard';
import { LineChartOutlined, BarChartOutlined } from '@ant-design/icons'
import ServerLogChart from '../../../Components/UI-Controls/Charts/ColumnChart/ServerLogChart';
import axios from 'axios';
import { security_key, Url } from '../../../Services/Api';
import BottomToust from "../../../Components/BottomToust/BottomToust";
import DataTable from "react-data-table-component";

const ServerLogs = () => {
    const [selectChart, setSelectChart] = useState('column-chart')
    const [logsData, setLogsData] = useState([]);
    const [data, setData] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [showMessage, setShowMessage] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [error, setError] = useState(null);
    const tableRef = useRef(null);

    const serverLogsCardData = [
        { title: `Top Api's`, icon: topApiIcon, value: 0 },
        { title: `Status Code Distribution`, icon: distributionsIcon, value: 0 },
        { title: `Avg Response Time`, icon: distributionsIcon, value: 0 },
        { title: `Frequency of methods`, icon: methodsIcon, value: 0 },
    ]

    const handleChartSelect = (chart) => {
        setSelectChart(chart)
    }

    const handleSelverLogsData = async () => {
        const token = sessionStorage.getItem('authToken');
        const headers = {
            Authorization: `Bearer ${token}`,
            'x-api-key': security_key
        };
        setError(null);
        const formattedDate = new Date().toISOString().split('T')[0];
        const api = `/logs?date=${formattedDate}`;
        try {
            const response = await axios.get(Url + api, {headers:headers});
            const validLogs = response.data.filter(log => !log.error);
            console.log("response inside function", response)
            const formateLogs = validLogs.map(log => ({
                timestamp: new Date(log.message.timestamp).toLocaleTimeString('en-US', {
                    timeZone: 'UTC',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: true
                }),
                duration: log.message.duration,
                ip: log.message.ip,
                method: log.message.method,
                route: log.message.route,
                status: log.message.status,
                userAgent: log.message.userAgent
            }))
            setLogsData(formateLogs)
            setToastMessage("Server Performance data have been fetched successfully!");
            setShowMessage(true);
        } catch (error) {
            const errMsg = error?.response?.data?.message || error.message;
            setError(errMsg);
            setToastMessage(`Failed to fetch Server Logs data: ${errMsg}`);
            setShowMessage(true);
        }
    }

    useEffect(() => { handleSelverLogsData() }, [])
    useEffect(() => { console.log("logs data", logsData) }, [logsData])

    const categories = [
        "12AM", "1AM", "2AM", "3AM", "4AM", "5AM", "6AM", "7AM", "8AM", "9AM", "10AM", "11AM",
        "12PM", "1PM", "2PM", "3PM", "4PM", "5PM", "6PM", "7PM", "8PM", "9PM", "10PM", "11PM",
    ];

    const logCounts = Object.fromEntries(categories.map(hour => [hour, 0]));

    logsData.forEach(log => {
        let timestamp = log.timestamp;
        let hourMatch = timestamp.match(/(\d{1,2}):\d{2}:\d{2} (AM|PM)/);

        if (hourMatch) {
            let hour = hourMatch[1] + hourMatch[2];
            if (logCounts.hasOwnProperty(hour)) {
                logCounts[hour]++;
            }
        }
    });

    const seriesData = categories.map(hour => logCounts[hour]);

    const chartData = {
        categories,
        seriesData
    };

    useEffect(() => {
        setData([...logsData].reverse().slice(0, 10))
        console.log("data logs for table", logsData)
    }, [logsData])

    useEffect(() => { console.log("data after set ", data) }, [data])

    const handleScroll = () => {
        if (!tableRef.current || !hasMore) return;

        const { scrollTop, scrollHeight, clientHeight } = tableRef.current;

        if (scrollTop + clientHeight >= scrollHeight - 20) {
            loadMoreData();
        }
    };

    const loadMoreData = () => {
        const nextData = logsData.slice(data.length, data.length + 10);
        if (nextData.length === 0) {
            setHasMore(false);
        } else {
            setData((prevData) => [...prevData, ...nextData]);
        }
    };

    useEffect(() => {
        const tableElement = tableRef.current;
        if (tableElement) {
            tableElement.addEventListener("scroll", handleScroll);
        }
        return () => {
            if (tableElement) {
                tableElement.removeEventListener("scroll", handleScroll);
            }
        };
    }, []);

    console.log("data for table", data)

    const columns = [
        {
            name: "Status",
            selector: (row) => row.status,
            sortable: true,
            cell: (row) => (
                <span
                    style={{
                        backgroundColor:
                            row.status >= 500
                                ? "#FFEBEE"
                                : row.status >= 400
                                    ? "#FFF3E0"
                                    : "#E8F5E9",
                        color:
                            row.status >= 500 ? "#D32F2F" : row.status >= 400 ? "#F57C00" : "#388E3C",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        display: "inline-block",
                    }}
                >
                    {row.status}
                </span>
            ),
        },
        { name: "Time", selector: (row) => row.timestamp, sortable: true },
        { name: "Method", selector: (row) => row.method, sortable: true },
        { name: "Route", selector: (row) => row.route, sortable: true },
        { name: "Duration", selector: (row) => row.duration, sortable: true },
        { name: "IP", selector: (row) => row.ip, sortable: true },
    ];

    const customStyles = {
        table: {
            style: {
                backgroundColor: "rgba(255, 255, 255, 0.7)",
            },
        },
        headRow: {
            style: {
                backgroundColor: "rgba(255, 255, 255, 0.6)",
                fontWeight: "bold",
                fontSize: "15px",
                textAlign: "center",
                position: "sticky",
                top: 0,
                zIndex: 1000,
            },
        },
        headCells: {
            style: {
                justifyContent: "center",
                paddingLeft: "10px",
                position: "sticky",
                top: 0,
                zIndex: 999,
            },
        },
        rows: {
            style: {
                backgroundColor: "transparent",
                textAlign: "center",
            },
        },
        cells: {
            style: {
                justifyContent: "center",
                paddingLeft: "10px",
            },
        },
        cellsConditionalStyles: [
            {
                when: (column) => column.name === "Route",
                style: {
                    justifyContent: "start",
                    paddingLeft: "10px",
                },
            },
            {
                when: (row) => row.route,
                style: {
                    textAlign: "start",
                    paddingLeft: "10px",
                },
            },
        ],
    };

    const handleCloseMessageModal = () => {
        setShowMessage(false);
    };

    useEffect(() => {
        if (showMessage === true) {
            const timeOut = setTimeout(() => {
                setShowMessage(false);
            }, 3000);

            return () => clearTimeout(timeOut);
        }
    }, [showMessage]);

    return (
        <div className='server-logs-main-container'>

            <div className='server-logs-card-and-chart-section'>

                <div className='server-logs-cards-and-head'>

                    <div className='server-log-head-section'>
                        <h3>Server Logs</h3>
                    </div>

                    <div className='server-log-cards-container'>
                        {serverLogsCardData.map((item, index) => (
                            <AnalyticCard
                                title={item.title}
                                value={item.value}
                                icon={item.icon}
                                width={'100%'}
                            />
                        ))}
                    </div>

                </div>

                <div className='server-logs-chart-container'>
                    <div className='server-log-chart-icons-container'>
                        <LineChartOutlined className={`server-log-icon ${selectChart === 'line-chart' ? 'active-chart-icon' : ''}`} onClick={() => handleChartSelect('line-chart')} />
                        <BarChartOutlined className={`server-log-icon ${selectChart === 'column-chart' ? 'active-chart-icon' : ''}`} onClick={() => handleChartSelect('column-chart')} />
                    </div>
                    <ServerLogChart data={chartData} selectedChart={selectChart} />
                </div>

            </div>

            <div className='server-logs-table-section'>
                <DataTable
                    columns={columns}
                    data={data}
                    noHeader
                    fixedHeader
                    customStyles={customStyles}
                />
            </div>

            <BottomToust
                showMessage={showMessage}
                message={toastMessage}
                handleCloseMessageModal={() => handleCloseMessageModal()}
            />
        </div>
    )
}

export default ServerLogs